import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/image 4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/image 5.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/image 6.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/image 7.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/image 8.svg");
